import { Helmet } from "react-helmet-async";

export default function Contact() {
  const title = "Contact — HeightPercentile.com";
  const description = "Get in touch with HeightPercentile.com for feedback, media, or partnership inquiries.";
  const url = (typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/contact";

  const breadcrumbLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: (typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/" },
      { "@type": "ListItem", position: 2, name: "Contact", item: url },
    ],
  };

  return (
    <main className="container mx-auto py-10 space-y-6">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={(typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/og-default.jpg"} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={(typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/og-default.jpg"} />
        <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      </Helmet>

      <h1>{title}</h1>
      <section className="prose prose-slate dark:prose-invert max-w-none">
        <p>For feedback or inquiries, please email us at <a className="underline" href="mailto:hello@heightpercentile.com">hello@heightpercentile.com</a>.</p>
      </section>
    </main>
  );
}
